import styled, {css} from 'styled-components';
import {Card} from '@material-ui/core';
import {AccentColorOptions} from 'epic-ue-theme';

const getRadialGradient = (from, to) =>
    `radial-gradient(100% 185.14% at 100% 100%, ${from} 0%, ${to} 100%)`;

export const UeLicenseCard = styled(Card)<{
    $activeBackgroundAccent?: AccentColorOptions;
    $width?: number;
}>`
    && {
        box-sizing: border-box;
        border-radius: 0;
        box-shadow: none;
        border: 0px;
        position: relative;
        background-color: ${(p) => p.theme.palette.background.default};
        color: ${(p) => p.theme.palette.text.secondary};
        height: 100%;
        padding: 0 ${(p) => p.theme.spacing(6)}px;
        width: ${(p) => (p.$width ? `${p.$width}px` : 'initial')};

        ${(p) => p.theme.breakpoints.down('md')} {
            width: 100%;
        }
        ${(p) => p.theme.breakpoints.down('sm')} {
            border: 1px solid ${(p) => p.theme.palette.neutral.silver};
        }

        ${(p) =>
            p.$activeBackgroundAccent &&
            css`
                color: ${(p) => p.theme.palette.common.black};
                ${(p) =>
                    p.$activeBackgroundAccent &&
                    `
                background-image: ${getRadialGradient(
                    p.theme.palette.gradient[p.$activeBackgroundAccent].from,
                    p.theme.palette.gradient[p.$activeBackgroundAccent].to
                )};
            `}
                svg {
                    color: ${(p) => p.theme.palette.common.black}!important;
                }
                .ue-rich-text {
                    border-color: ${(p) => p.theme.palette.common.black};
                    a {
                        color: ${(p) => p.theme.palette.common.black};
                        text-decoration: underline;
                        transition: color 0.3s ${(p) => p.theme.easing};
                        &:hover {
                            color: ${(p) => p.theme.palette.common.white};
                            background: unset;
                        }
                    }
                }
                a.ue-link-wrap {
                    transition: color 0.3s ${(p) => p.theme.easing};
                    &:hover {
                        color: ${(p) => p.theme.palette.common.white};
                    }
                }
                button.primary {
                    background: ${(p) => p.theme.palette.common.white};
                    &:hover {
                        background: ${(p) => p.theme.palette.common.white};
                        box-shadow: 0 0 18px ${(p) => p.theme.palette.common.white};
                    }
                }
                ${(p) => p.theme.breakpoints.down('sm')} {
                    border: none;
                }
            `}
    }
`;

export const UeLicenseContactCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    text-align: center;
    .paragraph {
        max-width: 510px;
        margin: 0 auto;
        padding: ${(p) => p.theme.spacing(6)}px ${(p) => p.theme.spacing(6)}px
            ${(p) => p.theme.spacing(4)}px;
    }

    .ue-link-wrap-span {
        padding-bottom: ${(p) => p.theme.spacing(7)}px;
    }

    ${(p) => p.theme.breakpoints.down('md')} {
        .paragraph {
            max-width: 510px;
            margin: 0 auto;
            padding: ${(p) => p.theme.spacing(5)}px ${(p) => p.theme.spacing(4)}px;
        }
    }
`;
